import { type StoryblokAlgoliaCategorySearchType } from '../../storyblok'

import {
  joinWithAnd,
  normalizeStringList,
  orSameAttribute,
} from './storyblokAlgoliaCategorySearchFiltersText'
import { nodeToClauses } from './storyblokAlgoliaCategorySearchFiltersTree'
import {
  ALGOLIA_ATTRIBUTES,
  type FilterNode,
} from './storyblokAlgoliaCategorySearchFiltersTypes'

export const storyblokAlgoliaCategoryOrPznSearchFilters = (
  blok: StoryblokAlgoliaCategorySearchType,
): string => {
  const categoryClause = orSameAttribute(
    ALGOLIA_ATTRIBUTES.categoryCodes,
    normalizeStringList(blok.categoryCode),
  )
  const pznClause = orSameAttribute(
    ALGOLIA_ATTRIBUTES.objectID,
    normalizeStringList(blok.pznList),
  )
  if (!categoryClause && !pznClause) {
    return ''
  }

  let categoryAndPznClause = ''

  if (!categoryClause) {
    categoryAndPznClause = pznClause
  }

  if (!pznClause) {
    categoryAndPznClause = categoryClause
  }

  if (categoryClause && pznClause) {
    categoryAndPznClause = `${pznClause} OR ${categoryClause}`
  }

  const groups: FilterNode[] = blok.additionalFilters ?? []
  const extraClauses = groups.flatMap((group) => nodeToClauses(group))

  return joinWithAnd([categoryAndPznClause, ...extraClauses])
}
